"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ContentContainer = exports.SpinnerContainer = exports.TextOverflow = exports.ButtonRoot = void 0;

var _designLanguage = require("@doordash/design-language");

var _constants = require("./constants");

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _utils = require("./utils");

var _utilities = require("@doordash/utilities");

var _templateObject, _KIND_MAPPING, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var RAISED_TRANSFORM = 'transform: scale(0.95)';
var PILL_BORDER_RADIUS = '1000px';

var getPadding = function getPadding(props) {
  if (props.kind === _constants.Types.Link) {
    return 0;
  }

  switch (props.padding) {
    case _constants.Padding.Wide:
      return props.size * 2;

    case _constants.Padding.None:
      return 0;

    default:
      return props.size;
  }
};

var getDisplay = function getDisplay(props) {
  return props.isInline ? 'inline-flex' : 'flex';
};

var getWidth = function getWidth(props) {
  if (props.shape === _designLanguage.Shape.Circle) {
    return "".concat(props.themeHeight, "px");
  }

  return props.isInline ? 'auto' : '100%';
};

var getJustifyContent = function getJustifyContent(props) {
  return props.isInline ? 'flex-start' : 'center';
};

var getShapeBorderRadius = function getShapeBorderRadius(props) {
  switch (props.shape) {
    case _designLanguage.Shape.Pill:
      return PILL_BORDER_RADIUS;

    case _designLanguage.Shape.Circle:
      return '100%';

    case _designLanguage.Shape.Rectangle:
    default:
      return "".concat(props.themeBorderRadius, "px");
  }
};

var getBorderRadius = function getBorderRadius(props) {
  switch (props.kind) {
    case _constants.Types.Full:
      return 0;

    case _constants.Types.PrimaryPill:
    case _constants.Types.SecondaryPill:
    case _constants.Types.TertiaryPill:
      return PILL_BORDER_RADIUS;

    case _constants.Types.Plain:
    default:
      return getShapeBorderRadius(props);
  }
};

var getDisabledStyle = function getDisabledStyle(props) {
  if (props.disabled) {
    return (0, _styledComponents.css)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n      &:hover {\n        cursor: not-allowed;\n      }\n      &:focus {\n        box-shadow: none;\n      }\n    "])));
  }

  return null;
};

var KIND_MAPPING = (_KIND_MAPPING = {}, _defineProperty(_KIND_MAPPING, _constants.Types.Primary, 'Primary'), _defineProperty(_KIND_MAPPING, _constants.Types.PrimaryPill, 'Primary'), _defineProperty(_KIND_MAPPING, _constants.Types.Full, 'Primary'), _defineProperty(_KIND_MAPPING, _constants.Types.Secondary, 'Secondary'), _defineProperty(_KIND_MAPPING, _constants.Types.SecondaryPill, 'Secondary'), _defineProperty(_KIND_MAPPING, _constants.Types.Tertiary, 'Tertiary'), _defineProperty(_KIND_MAPPING, _constants.Types.TertiaryPill, 'Tertiary'), _defineProperty(_KIND_MAPPING, _constants.Types.Destructive, 'Destructive'), _KIND_MAPPING);

var getFilledColorSet = function getFilledColorSet(_ref) {
  var isToggleable = _ref.isToggleable,
      isToggled = _ref.isToggled,
      kind = _ref.kind,
      themeColors = _ref.themeColors;
  var type = KIND_MAPPING[kind];
  return {
    "default": !isToggleable ? themeColors["Button".concat(type, "Background")] : !isToggled ? themeColors["Button".concat(type, "ToggleBackgroundOff")] : themeColors["Button".concat(type, "ToggleBackground")],
    hovered: !isToggleable ? themeColors["Button".concat(type, "BackgroundHovered")] : !isToggled ? themeColors["Button".concat(type, "ToggleBackgroundOffHovered")] : themeColors["Button".concat(type, "ToggleBackgroundHovered")],
    pressed: !isToggleable ? themeColors["Button".concat(type, "BackgroundPressed")] : !isToggled ? themeColors["Button".concat(type, "ToggleBackgroundOffPressed")] : themeColors["Button".concat(type, "ToggleBackgroundPressed")],
    disabled: !isToggleable ? themeColors["Button".concat(type, "BackgroundDisabled")] : !isToggled ? themeColors["Button".concat(type, "ToggleBackgroundOffDisabled")] : themeColors["Button".concat(type, "ToggleBackgroundDisabled")],
    border: !isToggleable ? type === 'Tertiary' ? themeColors["ButtonTertiaryBorder"] : 'transparent' : !isToggled ? themeColors["Button".concat(type, "ToggleBorderOff")] : themeColors["Button".concat(type, "ToggleBorderOn")],
    borderHovered: !isToggleable ? type === 'Tertiary' ? themeColors["ButtonTertiaryBorderHovered"] : 'transparent' : !isToggled ? themeColors["Button".concat(type, "ToggleBorderOffHovered")] : themeColors["Button".concat(type, "ToggleBorderOnHovered")],
    borderPressed: !isToggleable ? type === 'Tertiary' ? themeColors["ButtonTertiaryBorderPressed"] : 'transparent' : !isToggled ? themeColors["Button".concat(type, "ToggleBorderOffPressed")] : themeColors["Button".concat(type, "ToggleBorderOnPressed")],
    borderDisabled: !isToggleable ? type === 'Tertiary' ? themeColors["ButtonTertiaryBorderDisabled"] : 'transparent' : !isToggled ? themeColors["Button".concat(type, "ToggleBorderOffDisabled")] : themeColors["Button".concat(type, "ToggleBorderOnDisabled")],
    foregroundHovered: !isToggleable ? themeColors["Button".concat(type, "ForegroundHovered")] : !isToggled ? themeColors["Button".concat(type, "ToggleForegroundOffHovered")] : themeColors["Button".concat(type, "ToggleForegroundHovered")],
    foregroundPressed: !isToggleable ? themeColors["Button".concat(type, "ForegroundPressed")] : !isToggled ? themeColors["Button".concat(type, "ToggleForegroundOffPressed")] : themeColors["Button".concat(type, "ToggleForegroundPressed")],
    foregroundDisabled: !isToggleable ? themeColors["Button".concat(type, "ForegroundDisabled")] : !isToggled ? themeColors["Button".concat(type, "ToggleForegroundOffDisabled")] : themeColors["Button".concat(type, "ToggleForegroundDisabled")]
  };
};

var getColorSet = function getColorSet(props) {
  switch (props.kind) {
    case _constants.Types.FlatPrimary:
      return {
        disabled: props.themeColors.ButtonFlatPrimaryForegroundDisabled,
        hovered: props.themeColors.ButtonFlatPrimaryForegroundHovered,
        pressed: props.themeColors.ButtonFlatPrimaryForegroundPressed
      };

    case _constants.Types.FlatSecondary:
      return {
        disabled: props.themeColors.ButtonFlatSecondaryForegroundDisabled,
        hovered: props.themeColors.ButtonFlatSecondaryForegroundHovered,
        pressed: props.themeColors.ButtonFlatSecondaryForegroundPressed
      };

    case _constants.Types.Link:
      return {
        disabled: props.themeColors.ButtonLinkForegroundDisabled,
        hovered: props.themeColors.ButtonLinkForegroundHovered,
        pressed: props.themeColors.ButtonLinkForegroundPressed
      };

    case _constants.Types.Primary:
    case _constants.Types.PrimaryPill:
    case _constants.Types.Full:
    case _constants.Types.Destructive:
    case _constants.Types.Secondary:
    case _constants.Types.SecondaryPill:
    case _constants.Types.Tertiary:
    case _constants.Types.TertiaryPill:
      return getFilledColorSet(props);

    case _constants.Types.Plain:
      return {
        "default": props.isRaised ? props.themeColors.ButtonFabBackground : props.isToggleable ? props.isToggled ? props.themeColors.ButtonPlainToggleBackground : props.themeColors.ButtonPlainToggleBackgroundOff : props.themeColors.ButtonPlainBackground,
        hovered: props.isRaised ? props.themeColors.ButtonFabBackgroundHovered : props.isToggleable ? props.isToggled ? props.themeColors.ButtonPlainToggleBackgroundHovered : props.themeColors.ButtonPlainToggleBackgroundOffHovered : props.themeColors.ButtonPlainBackgroundHovered,
        pressed: props.isRaised ? props.themeColors.ButtonFabBackgroundPressed : props.isToggleable ? props.isToggled ? props.themeColors.ButtonPlainToggleBackgroundPressed : props.themeColors.ButtonPlainToggleBackgroundOffPressed : props.themeColors.ButtonPlainBackgroundPressed,
        disabled: props.isRaised ? props.themeColors.ButtonFabBackgroundDisabled : props.isToggleable ? props.isToggled ? props.themeColors.ButtonPlainToggleBackgroundDisabled : props.themeColors.ButtonPlainToggleBackgroundOffDisabled : props.themeColors.ButtonPlainBackgroundDisabled,
        border: 'transparent',
        borderHovered: 'transparent',
        borderPressed: 'transparent',
        borderDisabled: 'transparent',
        foregroundHovered: !props.isToggleable ? props.themeColors.ButtonPlainForegroundHovered : !props.isToggled ? props.themeColors.ButtonPlainToggleForegroundOffHovered : props.themeColors.ButtonPlainToggleForegroundHovered,
        foregroundPressed: !props.isToggleable ? props.themeColors.ButtonPlainForegroundPressed : !props.isToggled ? props.themeColors.ButtonPlainToggleForegroundOffPressed : props.themeColors.ButtonPlainToggleForegroundPressed,
        foregroundDisabled: !props.isToggleable ? props.themeColors.ButtonPlainForegroundDisabled : !props.isToggled ? props.themeColors.ButtonPlainToggleForegroundOffDisabled : props.themeColors.ButtonPlainToggleForegroundDisabled
      };

    default:
      throw Error("Unknown Button type provided: ".concat(props.kind));
  }
};

var getButtonBorderWidth = function getButtonBorderWidth(props) {
  if (props.themeBorderWidth && props.isToggleable) {
    if (props.isToggled) {
      return props.themeBorderWidth["Button".concat(KIND_MAPPING[props.kind], "Toggle")];
    }

    return props.themeBorderWidth["Button".concat(KIND_MAPPING[props.kind], "ToggleOff")];
  }

  return 1;
};

var getButtonStyle = function getButtonStyle(props) {
  var buttonBorder = "".concat(getButtonBorderWidth(props), "px");

  switch (props.kind) {
    case _constants.Types.FlatPrimary:
    case _constants.Types.FlatSecondary:
      return (0, _styledComponents.css)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n        background-color: transparent;\n        box-shadow: 0px 0px 0px 3px rgba(165, 211, 242, 0);\n        color: ", ";\n        * {\n          transition: color 0.15s ease-in-out;\n        }\n        &:focus {\n          ", ";\n        }\n        &:hover {\n          color: ", ";\n        }\n        &:active {\n          color: ", ";\n        }\n        ", ";\n      "])), props.themeColors[(0, _utils.colorForType)({
        isToggleable: props.isToggleable,
        isToggled: props.isToggled,
        buttonType: props.kind,
        isDisabled: props.disabled,
        isRaised: props.isRaised
      })], (0, _designLanguage.getFocusStyles)(), getColorSet(props).hovered, getColorSet(props).pressed, props.disabled && (0, _styledComponents.css)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n          ", ";\n          &:hover {\n            color: ", ";\n          }\n          &:active {\n            color: ", ";\n          }\n        "])), getDisabledStyle, getColorSet(props).disabled, getColorSet(props).disabled));

    case _constants.Types.Primary:
    case _constants.Types.PrimaryPill:
    case _constants.Types.Full:
    case _constants.Types.Destructive:
    case _constants.Types.Secondary:
    case _constants.Types.SecondaryPill:
    case _constants.Types.Tertiary:
    case _constants.Types.TertiaryPill:
    case _constants.Types.Plain:
      {
        var border = "inset 0 0 0 1px ".concat(getColorSet(props).border);
        return (0, _styledComponents.css)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n        background-color: ", ";\n        box-shadow: inset 0 0 0 ", " ", "\n          ", ";\n        color: ", ";\n        &:focus {\n          ", ";\n        }\n        &:hover {\n          background-color: ", ";\n          box-shadow: inset 0 0 0 ", " ", "\n            ", ";\n          color: ", ";\n        }\n        &:active {\n          background-color: ", ";\n          box-shadow: inset 0 0 0 ", " ", "\n            ", ";\n          ", ";\n          color: ", ";\n        }\n\n        ", ";\n      "])), props.isDepressed ? getColorSet(props).pressed : getColorSet(props)["default"], buttonBorder, getColorSet(props).border, props.isRaised ? ", ".concat(_designLanguage.Shadows.Large) : '', props.themeColors[(0, _utils.colorForType)({
          isToggleable: props.isToggleable,
          isToggled: props.isToggled,
          buttonType: props.kind,
          isDisabled: props.disabled,
          isRaised: props.isRaised
        })], (0, _designLanguage.getFocusStyles)({
          boxShadows: props.isRaised ? [border, _designLanguage.Shadows.Large] : [border]
        }), getColorSet(props).hovered, buttonBorder, getColorSet(props).borderHovered, props.isRaised ? ", ".concat(_designLanguage.Shadows.Large) : '', getColorSet(props).foregroundHovered, getColorSet(props).pressed, buttonBorder, getColorSet(props).borderPressed, props.isRaised ? ", ".concat(_designLanguage.Shadows.Base) : '', props.isRaised && RAISED_TRANSFORM, getColorSet(props).foregroundPressed, props.disabled && (0, _styledComponents.css)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n          ", ";\n          background-color: ", ";\n          box-shadow: inset 0 0 0 ", " ", "\n            ", ";\n          color: ", ";\n          &:hover {\n            background-color: ", ";\n            box-shadow: inset 0 0 0 ", " ", "\n              ", ";\n            color: ", ";\n          }\n          &:active {\n            background-color: ", ";\n            box-shadow: inset 0 0 0 ", " ", "\n              ", ";\n            ", ";\n            color: ", ";\n          }\n        "])), getDisabledStyle, getColorSet(props).disabled, buttonBorder, getColorSet(props).borderDisabled, props.isRaised ? ", ".concat(_designLanguage.Shadows.Large) : '', getColorSet(props).foregroundDisabled, getColorSet(props).disabled, buttonBorder, getColorSet(props).borderDisabled, props.isRaised ? ", ".concat(_designLanguage.Shadows.Large) : '', getColorSet(props).foregroundDisabled, getColorSet(props).disabled, buttonBorder, getColorSet(props).borderDisabled, props.isRaised ? ", ".concat(_designLanguage.Shadows.Base) : '', props.isRaised && RAISED_TRANSFORM, getColorSet(props).foregroundDisabled));
      }

    case _constants.Types.Link:
      return (0, _styledComponents.css)(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n        background-color: transparent;\n        box-shadow: none;\n        color: ", ";\n        &:focus {\n          ", ";\n        }\n        &:hover {\n          color: ", ";\n        }\n        &:active {\n          color: ", ";\n        }\n        ", ";\n      "])), props.themeColors[(0, _utils.colorForType)({
        isToggleable: props.isToggleable,
        isToggled: props.isToggled,
        buttonType: props.kind,
        isDisabled: props.disabled,
        isRaised: props.isRaised
      })], (0, _designLanguage.getFocusStyles)(), getColorSet(props).hovered, getColorSet(props).pressed, props.disabled && (0, _styledComponents.css)(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n          ", ";\n          &:hover {\n            color: ", ";\n          }\n          &:active {\n            color: ", ";\n          }\n        "])), getDisabledStyle, getColorSet(props).disabled, getColorSet(props).disabled));

    default:
      return null;
  }
};

var ButtonRoot = (0, _utilities.withDynamicTag)(_styledComponents["default"].button(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  position: relative;\n  max-width: 100%;\n  margin: 0;\n  padding: 0;\n  display: ", ";\n  ", "\n  width: ", ";\n  align-items: center;\n  justify-content: ", ";\n  border-radius: ", ";\n  border: none;\n  cursor: pointer;\n  transition: background-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n  user-select: none;\n  text-decoration: none;\n  text-align: center;\n  &::-moz-focus-inner {\n    outline: none;\n    border-style: none;\n    padding: 0;\n  }\n  ", ";\n  ", ";\n  ", ";\n"])), getDisplay, function (props) {
  return props.padding !== _constants.Padding.None && (0, _styledComponents.css)(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n      min-height: ", "px;\n    "])), props.themeHeight);
}, getWidth, getJustifyContent, getBorderRadius, getDisabledStyle, getButtonStyle, function (props) {
  return props.isIconButton && (0, _styledComponents.css)(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n      height: ", "px;\n      width: ", "px;\n      padding: 0;\n      align-items: center;\n      justify-content: center;\n    "])), props.themeHeight, props.themeHeight);
}));
exports.ButtonRoot = ButtonRoot;
var TextOverflow = (0, _styledComponents["default"])(_designLanguage.Inset).attrs({
  verticalSize: _designLanguage.Inset.Sizes.None,
  horizontalSize: function horizontalSize(props) {
    return getPadding(props);
  }
})(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n  max-width: 100%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n"])));
exports.TextOverflow = TextOverflow;

var SpinnerContainer = _styledComponents["default"].div(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 100%;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"])));

exports.SpinnerContainer = SpinnerContainer;

var getOpacityForVisibility = function getOpacityForVisibility(props) {
  return props.isHidden ? 0 : 1;
};

var ContentContainer = _styledComponents["default"].div(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n  flex-grow: 1;\n  max-width: 100%;\n  transition: opacity 0.15s ease-in-out;\n  opacity: ", ";\n"])), getOpacityForVisibility);

exports.ContentContainer = ContentContainer;